module.exports = __webpack_public_path__ + "img/VetoSansCond-Bold_1.54ec07ce.svg";